export default "/img/RS.e2f8c9acbdf884f5197efd604fc2d959.png";